import {
  VALIDATE_OTP_REQUEST,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILURE
} from 'actions/actionTypes';

const validateOTPReducer = (state = {}, action) => {
  switch (action.type) {
    case VALIDATE_OTP_REQUEST:
      return {
        loading: true,
        success: false,
        error: false
      };
    case VALIDATE_OTP_SUCCESS:
      return {
        loading: false,
        success: true,
        error: false
      };
    case VALIDATE_OTP_FAILURE:
      return {
        loading: false,
        success: false,
        error: true,
        errorMessage: action.payload.errorMessage
      };
    default:
      return state;
  }
};

export default validateOTPReducer;
